import React from 'react'

import styles from './AppFiltersLayout.module.scss'
import classNames from 'classnames'

interface Props {
  controls?: React.ReactNode
}

export const AppFiltersLayout: React.FC<Props> = ({ children, controls }) => {
  return (
    <div className={styles.layout}>
      <div className={styles.container}>{children}</div>
      <div className={classNames(styles.container, styles.controls)}>{controls}</div>
    </div>
  )
}
